<template>
  <div
    class="list-root"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="数据保存中，请耐心等待~"
    element-loading-spinner="el-icon-loading"
  >
    <query-condition-box>
      <el-form
        :inline="true"
        size="small"
        :model="searchParams"
        class="demo-form-inline"
      >
        <el-row style="padding-bottom: 10px">
          <el-col :span="24">
            <el-form
              label-position="right"
              ref="addActivityForm"
              :model="addActivityForm"
            >
              <span style="font-size: 16px !important; line-height: 3">
                活动信息
              </span>
              <br />
              <el-form-item required label="活动名称">
                <el-input
                  :disabled="seeDisabled"
                  v-model.trim="addActivityForm.title"
                  style="width: 400px"
                  placeholder="请输入活动名称"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <br />
              <el-form-item required label="活动时间">
                <el-date-picker
                  :disabled="seeDisabled || onlineStartTimeDisabled"
                  v-model="addActivityForm.startTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  style="width: 192px"
                  :default-time="defaultTime"
                  @change="startTimedatePickerChange"
                >
                </el-date-picker>
                -
                <el-date-picker
                  :disabled="seeDisabled"
                  v-model="addActivityForm.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 192px"
                  @change="endTimedatePickerChange"
                  default-time="23:59:59"
                >
                </el-date-picker>
                <!--                <el-date-picker-->
                <!--                  ref="datePicker"-->
                <!--                  :disabled="seeDisabled"-->
                <!--                  value-format="yyyy-MM-dd HH:mm:ss"-->
                <!--                  v-model="addActivityForm.activityTime"-->
                <!--                  type="datetimerange"-->
                <!--                  range-separator="至"-->
                <!--                  start-placeholder="开始日期"-->
                <!--                  end-placeholder="结束日期"-->
                <!--                  @change="datePickerChange"-->
                <!--                  :picker-options="pickerOptions"-->
                <!--                  :default-time="defaultTime"-->
                <!--                >-->
                <!--                </el-date-picker>-->
              </el-form-item>
              <br />
              <el-form-item required label="活动折扣">
                <el-input
                  :disabled="seeDisabled || discountDisabled"
                  @input="checkDiscount"
                  v-model.number="addActivityForm.discount"
                  style="width: 400px"
                  placeholder="请输入0~9之间的整数"
                >
                  <template slot="append">折</template>
                </el-input>
              </el-form-item>
            </el-form>
            <auth-dialog
              :dialog-visible.sync="auth.flag"
              :tip-type="auth.tipType"
            ></auth-dialog>
          </el-col>
        </el-row>
      </el-form>
    </query-condition-box>
    <div class="result-container">
      <span style="font-size: 16px; line-height: 3">内容信息</span>
      <br />
      <el-row>
        <el-col :span="24">
          <el-button
            :disabled="seeDisabled"
            @click="addActivityDialog"
            type="primary"
            icon="el-icon-plus"
            size="small"
            >添加内容
          </el-button>
          <el-dialog
            @closed="addContentDialogClose"
            title="添加内容"
            :visible.sync="dialogTableVisible"
          >
            <div style="width: 300px; display: flex; justify-content: left">
              <el-input
                v-model="addContentTableSearchParams.title"
                placeholder="请输入名称"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="addContentDialogSearchClick"
                ></el-button>
              </el-input>
            </div>
            <el-tabs v-model="activeName" @tab-click="addContentTabClick">
              <el-tab-pane label="资料" name="document">
                <el-table
                  @select-all="addContentTableSelectAll"
                  ref="multipleTableAddDocument"
                  v-loading="addContentTable.loading"
                  :data="addContentTable.data"
                  v-model="tableName"
                  @select="addContentTableSelect"
                >
                  <el-table-column
                    class-name="addDocumentSelectAllColumn"
                    :show-overflow-tooltip="true"
                    type="selection"
                    width="55"
                    :selectable="selectable"
                  >
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    label="资料名称"
                    prop="title"
                  >
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    width="350"
                    label="不可选择原因"
                    prop="forbidReason"
                  >
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-show="
                    addContentTable.total !== null &&
                    addContentTable.total !== 0
                  "
                  background
                  style="text-align: right; padding: 10px"
                  :current-page.sync="addContentTableSearchParams.pageIndex"
                  layout="slot,->,total, prev, pager, next"
                  :total="addContentTable.total"
                  :page-size="10"
                  @current-change="handleAddContentCurrentChange"
                >
                  <span class="el-pagination__total" style="display: flex">
                    已选：{{ selectedDoc.length }}
                  </span>
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane label="视频" name="video">
                <el-table
                  ref="multipleTableAddVideo"
                  v-loading="addContentTable.loading"
                  :data="addContentTable.data"
                  v-model="tableName"
                  @select="addContentTableSelect"
                >
                  <el-table-column
                    class-name="addDocumentSelectAllColumn"
                    :show-overflow-tooltip="true"
                    type="selection"
                    width="55"
                    :selectable="selectable"
                  >
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    label="视频名称"
                    prop="title"
                  >
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    align="left"
                    width="350"
                    label="不可选择原因"
                    prop="forbidReason"
                  >
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-show="
                    addContentTable.total !== null &&
                    addContentTable.total !== 0
                  "
                  background
                  style="text-align: right; padding: 10px"
                  :current-page.sync="addContentTableSearchParams.pageIndex"
                  layout="slot,->,total, prev, pager, next"
                  :total="addContentTable.total"
                  :page-size="10"
                  @current-change="handleAddContentCurrentChange"
                >
                  <span class="el-pagination__total" style="display: flex">
                    已选：{{ selectedDoc.length }}
                  </span>
                </el-pagination>
              </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogTableVisible = false">取消</el-button>
              <el-button @click="addContentToTable" type="primary"
                >确定</el-button
              >
            </span>
          </el-dialog>
        </el-col>
      </el-row>
      <br />
      <el-table
        style="border-radius: 5px; overflow: hidden"
        border
        stripe
        :header-cell-style="{
          color: '#333',
          background: '#f8f8f9',
          'text-align': 'center',
        }"
        ref="mainTable"
        row-key="documentId"
        v-loading="loading"
        :data="
          tableList.slice(
            (searchParams.pageIndex - 1) * searchParams.pageSize,
            searchParams.pageIndex * searchParams.pageSize
          )
        "
        v-model="tableName"
        @selection-change="delTableListChange"
      >
        <el-table-column
          class-name="mainTableSelect"
          :show-overflow-tooltip="true"
          type="selection"
          width="55"
          :selectable="mainTableselectable"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="内容名称"
          prop="title"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="内容类型"
          width="150"
          prop="resourceType"
        >
          <template v-slot="{ row }">
            {{
              row.resourceType === 1
                ? "资料"
                : row.resourceType === 3
                ? "视频"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="price"
          width="150"
          label="价格"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="discountPrice"
          width="150"
          label="折后价"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="200px">
          <template v-slot="{ row }">
            <el-link
              :disabled="seeDisabled"
              :underline="false"
              type="primary"
              @click="delSelectedContentInfo(row)"
              >删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="total !== null && total !== 0"
        background
        style="text-align: right; padding: 10px; padding-left: 0 !important"
        :current-page.sync="searchParams.pageIndex"
        layout="slot,->,total, prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        @current-change="handleMainTableCurrentChange"
      >
        <span style="display: flex">
          <el-button
            :disabled="seeDisabled"
            @click="delTableListClick"
            icon="el-icon-delete"
            >批量删除</el-button
          >
        </span>
      </el-pagination>
    </div>
    <div style="height: 60px"></div>
    <!-- 底部通栏 -->
    <footer class="footer">
      <div class="cancel" @click="cancelSave">取消</div>
      <div v-if="!seeDisabled" class="sure" @click="saveActivity">保存</div>
    </footer>
  </div>
</template>
<script>
import api from "@/assets/js/api";
import AuthDialog from "@/components/auth-dialog.vue";

export default {
  components: { AuthDialog },
  data() {
    return {
      onlineStartTimeDisabled: false,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const date = new Date(time);
          date.setHours(0, 0, 0, 0);
          return date < today;
        },
      },
      fullscreenLoading: false,
      // 1=add  2=edit 3=see
      operationType: null,
      activeName: "document",
      addContentTable: {
        total: 0,
        data: [],
        loading: false,
        tableName: "添加内容表格",
      },
      addContentTableSearchParams: {
        queryType: 1,
        shopId: this.$store.state.user.userInfo.shopId,
        title: null,
        pageSize: 10,
        pageIndex: 1,
        sortRule: "create_time$2",
        userId: this.$store.state.user.userInfo.userId,
        userName: this.$store.state.user.userInfo.userName,
        userTypeId: this.$store.state.user.userInfo.userTypeId,
      },
      addActivityForm: {
        unUpdateStartTime: false,
        discount: null,
        title: null,
        shopId: this.$store.state.user.userInfo.shopId,
        typeId: 1,
        sourceId: 1,
        startTime: null,
        endTime: null,
        operationType: 1,
        resourceList: [],
        userTypeId: this.$store.state.user.userInfo.userTypeId,
      },
      addActivityDataParams: {
        shopId: this.$store.state.user.userInfo.shopId,
        pageSize: 10000,
        pageIndex: 1,
        activityId: 0,
      },
      dialogTableVisible: false,
      auth: {
        flag: false,
        tipType: null,
      },
      dialogLoading: false,
      tableList: [],
      delTableList: [],
      loading: false,
      tableName: "内容列表",
      total: 0,
      searchParams: {
        time: "month",
        status: null,
        shopId: this.$store.state.user.userInfo.shopId,
        title: null,
        pageSize: 10,
        pageIndex: 1,
      },
      // add content list
      selectedDoc: [],
      editId: null,
      seeDisabled: false,
      discountDisabled: false,
      // router flag
      isSaved: false,
    };
  },
  computed: {
    defaultTime: () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = (now.getMinutes() + 5).toString().padStart(2, "0");
      return `${hours}:${minutes}:00`;
    },
  },
  // 路由守卫
  beforeRouteLeave(to, from, next) {
    // 如果保存操作后的跳转 直接跳转
    if (this.isSaved) {
      next();
    } else {
      this.$confirm("此时离开将丢失已编辑的内容，是否确认离开？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
          this.$store.commit("setActiveIndex", "/marketing/discount");
        });
    }
  },
  async created() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const operationType = params.get("operationType");
    if (operationType == null || (!operationType == 1 && id == null)) {
      window.location.href = "/marketing/discount";
      return;
    }
    if (id) {
      this.editId = id;
      await this.getEditActivityInfo(this.editId);
    }
    this.operationType = operationType;
    if (operationType == 2) {
      if (params.get("online") == "true") {
        this.discountDisabled = true;
        this.onlineStartTimeDisabled = true;
        this.unUpdateStartTime = true;
      }
      this.addActivityDataParams.activityId = id;
      await this.getEditActivityTableData();
    } else if (operationType == 3) {
      this.addActivityDataParams.activityId = id;
      await this.getEditActivityTableData();
      this.seeDisabled = true;
      const checkbox = document.querySelector(
        ".el-table__header-wrapper .mainTableSelect .el-checkbox"
      );
      if (checkbox) {
        checkbox.setAttribute("style", "display:none");
      }
    }
    if (this.$route.params.pageIndex) {
      this.searchParams.pageIndex = this.$route.params.pageIndex;
    }
  },
  mounted() {
    // this.setTime();
    if (this.$route.params.pageIndex) {
      this.searchParams.status = this.$route.params.status;
      this.searchParams.title = this.$route.params.title;
      this.searchParams.pageIndex = this.$route.params.pageIndex;
    }
    //this.getTableList();
  },
  methods: {
    async addContentDialogSearchClick() {
      this.addContentTableSearchParams.pageIndex = 1;
      if (this.activeName === "document") {
        this.addContentTableSearchParams.queryType = 1;
      } else if (this.activeName === "video") {
        this.addContentTableSearchParams.queryType = 2;
      }
      await this.getAddContentTable();
    },
    mainTableselectable() {
      return !this.seeDisabled;
    },
    selectable(row) {
      if (row.forbidReason) {
        return false;
      }
      return !this.tableList.find((obj) => obj.documentId === row.documentId);
    },
    async getEditActivityInfo(id) {
      let _that = this;
      const activityInfo = await _that.$axios.get(
        api.activity.getActivityInfo + "?id=" + id
      );
      if (!activityInfo.valid) {
        return;
      }
      if (activityInfo.result) {
        this.addActivityForm.title = activityInfo.result.title;
        this.addActivityForm.discount = activityInfo.result.discount / 10.0;
        this.addActivityForm.startTime = activityInfo.result.startTime.replace(
          "T",
          " "
        );
        this.addActivityForm.endTime = activityInfo.result.endTime.replace(
          "T",
          " "
        );
        if (this.addActivityForm.startTime) {
          const year = this.addActivityForm.startTime.substring(0, 4);
          if (year == 2099) {
            // this.addActivityForm.activityTime = null;
            this.addActivityForm.startTime = null;
            this.addActivityForm.endTime = null;
            this.addActivityForm.title = null;
          }
        }
      }
    },
    async getEditActivityTableData() {
      let _that = this;
      _that.loading = true;
      const tableList = await this.$axios.post(
        api.activity.getActivityData,
        _that.addActivityDataParams
      );
      if (!tableList.result.list) {
        tableList.result.list = [];
      }
      _that.tableList = tableList.result.list;
      for (let i = 0; i < _that.tableList.length; i++) {
        if (_that.tableList[i].title == null) {
          _that.tableList[i].title = `当前${
            _that.tableList[i].resourceType === 1 ? "资料" : "视频"
          }已退稿（${
            _that.tableList[i].resourceType === 1 ? "资料" : "视频"
          }id：${_that.tableList[i].documentId}）`;
          _that.tableList[i].price = "--";
          _that.tableList[i].discountPrice = "--";
        }
      }
      _that.total = tableList.result.totalCount;
      _that.loading = false;
    },
    delTableListClick() {
      let _that = this;
      if (this.delTableList == null || this.delTableList.length === 0) {
        this.$message.warning("请勾选需要删除的内容");
        return;
      }
      this.$confirm(
        `是否确定删除已选的${_that.delTableList.length}个内容?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          let ids = _that.delTableList.map((item) => item.documentId);
          _that.tableList = _that.tableList.filter(function (item) {
            return !ids.includes(item.documentId);
          });
          _that.$refs.mainTable.clearSelection();
          _that.total = this.total - ids.length;
          if (!_that.tableList) {
            _that.total = 0;
          }
        })
        .catch(() => {});
    },
    delTableListChange(selection) {
      this.delTableList = selection;
    },
    async addContentTabClick() {
      let _that = this;
      _that.addContentTableSearchParams.pageIndex = 1;
      this.$refs.multipleTableAddDocument.clearSelection();
      this.$refs.multipleTableAddVideo.clearSelection();
      this.selectedDoc = [];
      if (this.activeName === "document") {
        _that.addContentTableSearchParams.queryType = 1;
        await _that.getAddContentTable();
      } else if (this.activeName === "video") {
        _that.addContentTableSearchParams.queryType = 2;
        await _that.getAddContentTable();
      }
    },
    startTimedatePickerChange(val) {
      if (this.addActivityForm.endTime <= val) {
        this.$message.warning("请选择小于结束时间");
        //this.addActivityForm.activityTime = null;
        this.addActivityForm.startTime = null;
      }
    },
    endTimedatePickerChange(val) {
      if (this.addActivityForm.startTime >= val) {
        this.$message.warning("请选择大于开始时间");
        //this.addActivityForm.activityTime = null;
        this.addActivityForm.endTime = null;
      }
    },
    async saveActivity() {
      let _that = this;
      this.fullscreenLoading = true;
      if (
        _that.addActivityForm.title == null ||
        _that.addActivityForm.title === ""
      ) {
        _that.$message.error("请输入活动名称");
        this.fullscreenLoading = false;
        return;
      }
      if (
        _that.addActivityForm.startTime == null ||
        _that.addActivityForm.startTime === "" ||
        _that.addActivityForm.endTime == null ||
        _that.addActivityForm.endTime === ""
      ) {
        _that.$message.error("请选择活动时间");
        this.fullscreenLoading = false;
        return;
      }
      if (
        _that.addActivityForm.discount == null ||
        _that.addActivityForm.discount === ""
      ) {
        _that.$message.error("请输入活动折扣");
        this.fullscreenLoading = false;
        return;
      }
      _that.addActivityForm.resourceList = [];
      for (const item of _that.tableList) {
        let resObj = {
          resourceId: item.documentId,
          resourceType: item.resourceType,
        };
        _that.addActivityForm.resourceList.push(resObj);
      }
      _that.addActivityForm.resourceList = [
        ...new Set(_that.addActivityForm.resourceList),
      ];
      let addRes;
      if (_that.operationType == 1) {
        _that.addActivityForm.id = null;
        addRes = await _that.$axios.post(
          api.activity.addShopActivity,
          _that.addActivityForm
        );
      } else if (_that.operationType == 2) {
        _that.fullscreenLoading = true;
        // 检测资料
        let checkRes = await _that.$axios.post(api.activity.checkResource, {
          ids: _that.addActivityForm.resourceList.map((doc) => doc.resourceId),
          startTime: _that.addActivityForm.startTime,
          endTime: _that.addActivityForm.endTime,
          userTypeId: _that.$store.state.user.userInfo.userTypeId,
          activityId: _that.editId,
        });
        _that.fullscreenLoading = false;
        if (checkRes.valid && checkRes.result !== 0) {
          await _that
            .$confirm(
              `有${checkRes.result}个内容不符合添加条件，需要删除`,
              "提示",
              {
                confirmButtonText: "确定删除",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
            .then(async () => {
              //_that.$message.info("数据保存中，请耐心等待~");
              _that.fullscreenLoading = true;
              _that.addActivityForm.id = _that.editId;
              addRes = await _that.$axios.post(
                api.activity.updateActivity,
                _that.addActivityForm
              );
              _that.fullscreenLoading = false;
            });
        } else {
          _that.addActivityForm.id = _that.editId;
          addRes = await _that.$axios.post(
            api.activity.updateActivity,
            _that.addActivityForm
          );
        }
      }
      if (addRes.valid && addRes.result) {
        _that.$message.success("保存成功");
        this.isSaved = true;
        await _that.$router.push({
          name: "marketing-discount",
          params: this.$route.params,
        });
      } else if (!addRes.valid && addRes.error.message) {
        _that.$message.error(addRes.error.message);
      } else {
        _that.$message.error("保存失败");
      }
      this.fullscreenLoading = false;
    },
    cancelSave() {
      this.$router.push({
        name: "marketing-discount",
        params: this.$route.params,
      });
    },
    addContentDialogClose() {
      this.activeName = "document";
      this.addContentTableSearchParams.queryType = 1;
      this.$refs.multipleTableAddDocument.clearSelection();
      this.$refs.multipleTableAddVideo.clearSelection();
      this.addContentTableSearchParams.title = null;
    },
    delSelectedContentInfo(row) {
      this.tableList = this.tableList.filter(function (item) {
        return item.documentId !== row.documentId;
      });
      this.total = this.total - 1;
    },
    addContentTableSelect(selection, row) {
      const selectedDocRes = this.selectedDoc.find(
        (item) => item && item.documentId === row.documentId
      );
      if (selectedDocRes) {
        this.selectedDoc = this.selectedDoc.filter(
          (obj) => obj && obj.documentId !== row.documentId
        );
      } else {
        this.selectedDoc.push(row);
      }
    },
    addContentTableSelectAll(selection) {
      // console.log("selectAll", selection);
      this.selectedDoc = selection;
      // console.log("selectedDoc", this.selectedDoc);
      // let _that = this;
      // selection.forEach((item) => {
      //   const findRes = _that.selectedDoc.find((obj) => {
      //     item.documentId === obj.documentId;
      //   });
      //   if(findRes){
      //
      //   }
      // });
    },
    addContentToTable() {
      this.dialogTableVisible = false;
      // this.tableList.push(...this.selectedDoc);
      this.tableList.unshift(
        ...this.selectedDoc
          .filter(
            (doc) =>
              !this.tableList.some((item) => item.documentId === doc.documentId)
          )
          .reverse()
      );
      if (this.tableList) {
        for (let i = 0; i < this.tableList.length; i++) {
          if (this.tableList[i].price !== 0) {
            this.tableList[i].discountPrice =
              (this.tableList[i].price * this.addActivityForm.discount) / 10.0;
          } else if (this.tableList[i].price === 0) {
            this.tableList[i].discountPrice = 0;
          }
        }
      }
      this.total = this.total + this.selectedDoc.length;
      if (this.selectedDoc.length > 0) {
        this.$message.success("添加成功");
      }
    },
    checkDiscount() {
      if (
        !(
          this.addActivityForm.discount >= 0 &&
          this.addActivityForm.discount <= 9
        )
      ) {
        this.addActivityForm.discount = null;
        this.$message.warning("请输入0~9之间的整数");
      }
      if (this.tableList) {
        // 精度计算 勿动
        for (let i = 0; i < this.tableList.length; i++) {
          this.tableList[i].discountPrice =
            (this.addActivityForm.discount *
              10 *
              (this.tableList[i].price * 100)) /
            10000;
        }
      }
    },
    async addActivityDialog() {
      let _that = this;
      if (
        _that.addActivityForm.startTime == null ||
        _that.addActivityForm.startTime === "" ||
        _that.addActivityForm.endTime == null ||
        _that.addActivityForm.endTime === ""
      ) {
        _that.$message.warning("请先选择活动时间");
        return;
      }
      if (!_that.addActivityForm.discount) {
        _that.$message.warning("请先输入活动折扣");
        return;
      }
      this.activeName = "document";
      this.addContentTableSearchParams.queryType = 1;
      this.addContentTableSearchParams.pageIndex = 1;
      this.selectedDoc = [];
      await _that.getAddContentTable();
      _that.dialogTableVisible = true;
    },
    showAddContentTableCheckedItem() {
      let _that = this;
      if (_that.selectedDoc) {
        this.$nextTick(() => {
          _that.selectedDoc.forEach((checkedItem) => {
            this.$refs.multipleTableAddDocument.toggleRowSelection(
              this.addContentTable.data.find((item) => {
                return (
                  checkedItem && checkedItem.documentId === item.documentId
                );
              }),
              true
            );
            this.$refs.multipleTableAddVideo.toggleRowSelection(
              this.addContentTable.data.find((item) => {
                return item && item.documentId === checkedItem.documentId;
              }),
              true
            );
          });
        });
      }
    },
    async getAddContentTable() {
      this.addContentTable.loading = true;
      this.addContentTableSearchParams.startTime =
        this.addActivityForm.startTime;
      this.addContentTableSearchParams.endTime = this.addActivityForm.endTime;
      if (this.operationType == 2 && this.editId) {
        this.addContentTableSearchParams.activityId = this.editId;
      }
      const tableList = await this.$axios.post(
        api.activity.getVideoOrResourceListV2,
        this.addContentTableSearchParams
      );
      if (tableList && tableList.list) {
        for (let i = 0; i < tableList.list.length; i++) {
          if (tableList.list[i].type4.id === 410702) {
            tableList.list[i].resourceType = 3;
          } else if (tableList.list[i].type4.id !== 410702) {
            tableList.list[i].resourceType = 1;
          }
        }
      }

      this.addContentTable.data = tableList.list;
      this.addContentTable.total = tableList.totalCount;
      this.addContentTable.loading = false;
    },
    async delActivity(row) {
      let _that = this;
      this.$confirm("是否确定删除该活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let delRequestBody = {
            shopId: _that.$store.state.user.userInfo.shopId,
            id: row.id,
          };
          const copyRes = await _that.$axios.post(
            api.activity.delShopActivity,
            delRequestBody
          );
          if (copyRes.valid && copyRes.result) {
            _that.$message.success("删除成功");
            await _that.getTableList();
          } else {
            _that.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    //获取列表
    async getTableList() {
      this.loading = true;
      const tableList = await this.$axios.post(
        api.activity.pageShopActivityList,
        this.searchParams
      );
      this.tableList = tableList.result.list;
      this.total = tableList.result.totalCount;
      this.loading = false;
    },
    // 修改当前页
    handleCurrentChange(pageIndex) {
      this.searchParams.pageIndex = pageIndex;
      //请求
      this.getTableList();
    },
    async handleAddContentCurrentChange(pageIndex) {
      this.addContentTableSearchParams.pageIndex = pageIndex;
      //请求
      await this.getAddContentTable();
      this.showAddContentTableCheckedItem();
    },
    handleMainTableCurrentChange(pageIndex) {
      this.searchParams.pageIndex = pageIndex;
    },
    getCurrentDateString() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.result-container {
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}

//::v-deep .has-gutter .el-table__cell {
//  &:first-of-type {
//    text-align: left !important;
//  }
//}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-dialog__header {
  text-align: left;
}

::v-deep .el-table__header-wrapper .addDocumentSelectAllColumn .el-checkbox {
  display: none;
}

.footer {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  // bottom: -20px;
  // right: -20px;
  bottom: 0;
  right: 0;
  width: calc(100% + 40px);
  height: 70px;
  background-color: #fff;

  .cancel {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 32px;
    margin-right: 60px;
    transform: translateX(120px);
    background: #ffffff;
    border: 1px solid #dddfe6;
    border-radius: 3px;
    color: #606266;
    cursor: pointer;
  }

  .sure {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 32px;
    transform: translateX(120px);
    color: #fff;
    background: #5a83ff;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
